
import { __ } from 'bits/intl'
import { Component, Prop, Vue } from 'bits/vue'
import ImageThumbnail from 'library/v4/components/ImageThumbnail.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzListRow, { OzListRowSeparator } from 'library/v4/components/OzListRow.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import RelativeTime from 'library/v4/components/relative-time.vue'
import type { Wall as WallSnakeCase, WallCamelCase as Wall } from 'types'

@Component({ components: { OzListRow, ImageThumbnail, RelativeTime, OzIcon, OzTextButton } })
export default class OzWallListRow extends Vue {
  OzTextButtonColorScheme = OzTextButtonColorScheme

  /**
   * Dark mode
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Invert colors
   */
  @Prop({ default: false }) invertColors!: boolean

  /**
   * Wall to display
   */
  @Prop({ required: true }) wall!: Wall | WallSnakeCase

  /**
   * The timestamp type to show.
   */
  @Prop({ default: 'updatedAt' }) dateAttribute!: string

  /**
   * Set this to false to use normal cursor, tabindex -1 etc
   */
  @Prop({ default: true }) clickable!: boolean

  /**
   * Show the more button
   */
  @Prop({ default: false }) xMore!: boolean

  /**
   * Separator type
   */
  @Prop({ default: OzListRowSeparator.Short }) separator!: OzListRowSeparator

  get title(): string {
    return this.wall.title || __('Untitled padlet')
  }

  get dominantColorAsRgb(): string {
    return (
      (this.wall as Wall).thumbnail.dominantColorAsRgb || (this.wall as WallSnakeCase).thumbnail.dominant_color_as_rgb
    )
  }

  get builderDisplayName(): string {
    return (this.wall as Wall).builder.displayName || (this.wall as WallSnakeCase).builder.display_name
  }

  get date(): string {
    if (this.dateAttribute === 'updatedAt') {
      return (this.wall as Wall).updatedAt || (this.wall as WallSnakeCase).updated_at
    } else {
      return this.wall[this.dateAttribute]
    }
  }

  select(): void {
    /**
     * Select the wall.
     */
    this.$emit('select', this.wall)
  }

  more(): void {
    /**
     * View more wall actions.
     */
    this.$emit('more', this.wall)
  }
}

export { OzListRowSeparator }
